import { render, staticRenderFns } from "./ProfileUpdateRequest.vue?vue&type=template&id=08474faa&"
import script from "./ProfileUpdateRequest.vue?vue&type=script&lang=js&"
export * from "./ProfileUpdateRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports